// TODO: Figure out a way of making this stable across SSR/SSG/CSR boundary
// See: https://github.com/sveltejs/svelte/issues/7517
export function generateUniqueElementId() {
  return 'id' + Math.random().toString();
}
